"use client";
import React from "react";

type ChatFollowUpQuestionsProps = {
  questions: string[];
  onSelect: (question: string) => void;
  disabled?: boolean;
  className?: string;
  textColor?: string;
};

export const normalizeFollowUpQuestions = (questions?: unknown): string[] => {
  if (!Array.isArray(questions)) return [];

  return Array.from(
    new Set(
      questions
        .filter((question): question is string => typeof question === "string")
        .map((question) => question.trim())
        .filter(Boolean),
    ),
  );
};

const ChatFollowUpQuestions = ({
  questions,
  onSelect,
  disabled = false,
  className = "",
  textColor,
}: ChatFollowUpQuestionsProps) => {
  if (!questions.length) return null;

  return (
    <div
      className={`ff_poppins w-full mt-4 ${className}`}
      aria-label="Suggested follow-up questions"
    >
      <div className="bg-white rounded-[16px] shadow-sm overflow-hidden flex flex-col">
        {questions.map((question, index) => (
          <button
            key={`${question}-${index}`}
            type="button"
            onClick={() => onSelect(question)}
            disabled={disabled}
            style={textColor ? { color: textColor } : undefined}
            className="group flex cursor-pointer items-start gap-3 border-b border-[#F3F4F6] px-4 py-3 text-left text-[14px] leading-5 transition-colors duration-150 last:border-0 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-60"
          >
            <span className="mt-0.5 shrink-0 text-lg font-medium leading-none text-[#9CA3AF] transition-colors group-hover:text-[#867bff]">
              ↳
            </span>

            <span className="mt-0.5">{question}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ChatFollowUpQuestions;